<template>
  <div class="search_box">
    <div class="search-items">
      <el-radio-group v-model="shidian" @change="shidianClick">
        <el-radio-button v-for="item in shidianOpt" :label="item.value">{{ item.label }}</el-radio-button>
      </el-radio-group>
    </div>

    <div class="search-items yuefen">
      <span class="text" v-if="type == 'YY'">近5年</span>
      <span class="text" v-if="type == 'SS'">近5个季度</span>
      <template v-if="type == 'MM'">
        <el-select v-model="yuefen" style="width:113px" @change="yuefenClick">
          <el-option v-for="item in yuefenOpt" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </template>
    </div>
  </div>
</template>

<script setup>
  import { ElSelect, ElOption, ElRadioGroup, ElRadioButton } from 'element-plus';
  import { ref, watch } from 'vue';
  import { useStore } from 'vuex';

  const shidianOpt = [
    { value: 'time', label: '按时间查询' },
    { value: 'area', label: '按地区查询' },
  ];
  const yuefenOpt = [
    { value: '12', label: '近12个月' },
    { value: '24', label: '近24个月' },
  ];
  const store = useStore();
  const emits = defineEmits();
  const shidian = ref('time');
  const yuefen = ref('12');
  let type = ref('YY');

  const shidianClick = (val) => {
    emits('shidianClick', val);
  };
  const yuefenClick = (val) => {
    emits('yuefenClick', val);
  };

  watch(
    () => store.state.dtType,
    (nv) => {
      type.value = nv;
    }
  );
</script>

<style lang="less" scoped>
  .search_box {
    display: flex;
    align-items: center;
    background-color: #fff;

    .search-items {
      margin-right: 20px;
      &.yuefen {
        display: flex;
        align-items: center;
      }
    }

    :deep(.el-radio-button) {
      --el-radio-button-checked-bg-color: var(--light-color);
      --el-radio-button-checked-border-color: var(--light-color);
      .el-radio-button__inner {
        line-height: 18px;
        border-color: var(--light-color);
      }
    }
    :deep(.el-select) {
      .el-input.is-focus .el-input__wrapper {
        box-shadow: 0 0 0 1px var(--light-color) inset !important;
      }
    }

    :deep(.el-input__wrapper) {
      --font-color: #000;
      padding-left: 15px;
      padding-top: 3px;
      padding-bottom: 3px;

      input {
        color: var(--font-color);
      }
      .el-select__icon {
        color: var(--font-color);
      }
    }
  }
</style>